import React from 'react';
import Article from '../../components/article/Article';
import { blog01, blog02, blog03, blog04, blog05 } from './imports';
import './blog.css';

const Blog = () => (
  <div className="gpt3__blog section__padding" id="blog">
    <div className="gpt3__blog-heading">
      <h1 className="gradient__text">Hear the Latest <br /> In the world of Gym Workouts</h1>
    </div>
    <div className="gpt3__blog-container">
      <div className="gpt3__blog-container_groupA">
        <Article imgUrl={blog01} date="Sep 26, 2021" text="What Each Lat Pulldown Attachment Does" />
      </div>
      <div className="gpt3__blog-container_groupB">
        <Article imgUrl={blog02} date="Sep 26, 2022" text="The Benefits Of Salt Pre-Workout" />
        <Article imgUrl={blog03} date="Aug 06, 2022" text="Hammer Curls vs Normal Curls" />
        <Article imgUrl={blog04} date="Jul 26, 2022" text="Seated Row Done Correctly" />
        <Article imgUrl={blog05} date="Jun 26, 2022" text="Barbell Curl Alternatives For Jacked Biceps" />
      </div>
    </div>
  </div>
);

export default Blog;
